import * as React from 'react';
import { makeStyles, tokens, Button, Tooltip } from '@fluentui/react-components';
import { CopyRegular } from '@fluentui/react-icons';
import { COPILOT_CONSTANTS } from '../constants';

interface ErrorMessageProps {
  message: string;
  originalError?: Error | string;
  onCopy?: () => void;
}

const useStyles = makeStyles({
  defaultMessageContainer: {
    padding: "14px 0 0 0",
  },
  messageContainer: {
    padding: "0 0 8px 0",
    margin: 0,
  },
  actionBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end', 
    marginTop: '8px',
  },
  copyButton: {
    minWidth: 'auto',
    padding: '4px',
    height: '24px',
    opacity: 0.7,
    '&:hover': {
      opacity: 1
    }
  }
});

const ErrorMessage: React.FC<ErrorMessageProps> = ({ 
  message, 
  originalError, 
  onCopy 
}) => {
  const styles = useStyles();
  
  const displayMessage = message || COPILOT_CONSTANTS.MESSAGES.SYSTEM_ISSUE;

  const handleCopy = () => {
    if (onCopy) {
      onCopy();
    }
  };

  return (
    <div className={styles.defaultMessageContainer} data-message-type="error">
      <div className={styles.messageContainer}>
        {displayMessage}
      </div>
      
      {/* Action buttons - similar to legacy ChatBotActionButtons 
      <div className={styles.actionBar}>
        <Tooltip content="Copy error message" relationship="label">
          <Button
            appearance="subtle"
            size="small"
            className={styles.copyButton}
            icon={<CopyRegular />}
            onClick={handleCopy}
            aria-label="Copy error message"
            tabIndex={0}
          />
        </Tooltip>
      </div>*/}
    </div>
  );
};

export default ErrorMessage;